import { Link } from '@tanstack/react-router';
import { ArrowRight } from 'lucide-react';

import { useFeatureFlagState } from '@/hooks/use-feature-flag-state';
import { LOGGER_ACTIONS, logger } from '@/lib/logger';

export function ManageOrderBanner() {
  const flagState = useFeatureFlagState('self-serve-order-lookup');

  if (flagState !== 'enabled') {
    return null;
  }

  return (
    <div className="relative left-1/2 flex w-screen -translate-x-1/2 items-center justify-center bg-marigold-500 px-4 py-5">
      <p className="flex flex-wrap items-center justify-center gap-2 text-center text-sm text-charcoal-900">
        <span>Looking for an existing order?</span>
        <Link
          to="/order-lookup"
          onClick={() => logger.action(LOGGER_ACTIONS.ORDER_LOOKUP.BANNER_CLICKED)}
          className="inline-flex items-center gap-2 font-medium text-charcoal-900 underline underline-offset-auto"
        >
          Manage my order
          <ArrowRight className="size-4" aria-hidden="true" />
        </Link>
      </p>
    </div>
  );
}
